import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,

};

export const getResumeShortlistList = createAsyncThunk(
    "getResumeShortlistList",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/shortlist/fetch-ai-shortlist?page=${body.page}&search=${body.search}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);


export const ResumeShortListSlice = createSlice({
    name: "ResumeShortListSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getResumeShortlistList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getResumeShortlistList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(getResumeShortlistList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default ResumeShortListSlice.reducer;
